'use strict';

var BaseView = require('./base');

class MatrixRowView extends BaseView {
    constructor(matrix, row) {
        super(matrix, 1, matrix.columns);
        this.row = row;
    }

    set(rowIndex, columnIndex, value) {
        this.matrix.set(this.row, columnIndex, value);
        return this;
    }

    get(rowIndex, columnIndex) {
        return this.matrix.get(this.row, columnIndex);
    }
}

module.exports = MatrixRowView;



//////////////////
// WEBPACK FOOTER
// ./~/ml-matrix/src/views/row.js
// module id = 123
// module chunks = 0